import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.399 14.4-2.4-2.4m0 0-2.4-2.4M12 12l-2.4 2.4M12 12l2.4-2.4m7.2 2.4s-.291 2.692-.815 3.878l.817 5.721-4.903-1.226a9.56 9.56 0 0 1-4.699 1.227 9.6 9.6 0 1 1 9.6-9.6"
    />
  </svg>
);
export default SvgMessageX;
